var React = require('react');

function ChatInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9 1.5H2.1C1.495 1.5 1 1.995 1 2.6V12.5L3.2 10.3H10.9C11.505 10.3 12 9.805 12 9.2V2.6C12 1.995 11.505 1.5 10.9 1.5Z","stroke":"currentColor","strokeWidth":"1.2"}));
}

ChatInline.defaultProps = {"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none"};

module.exports = ChatInline;

ChatInline.default = ChatInline;
